import { render, staticRenderFns } from "./order_edit.vue?vue&type=template&id=7170e8c7&scoped=true"
import script from "./order_edit.vue?vue&type=script&lang=js"
export * from "./order_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7170e8c7",
  null
  
)

export default component.exports